import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock, ShieldCheck } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { ADMIN_CREDS } from '../data/mock';
import { useToast } from '../hooks/use-toast';

const AdminLogin = () => {
  const navigate = useNavigate();
  const { toast } = useToast();
  const [form, setForm] = useState({ username: '', password: '' });

  const handleSubmit = (e) => {
    e.preventDefault();
    if (form.username === ADMIN_CREDS.username && form.password === ADMIN_CREDS.password) {
      localStorage.setItem('es_admin_auth', '1');
      toast({ title: 'Welcome back, Admin' });
      navigate('/admin/dashboard');
    } else {
      toast({ title: 'Invalid credentials', variant: 'destructive' });
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-50 via-white to-orange-50 flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="bg-white rounded-xl shadow-xl border border-gray-200 p-8">
          <div className="text-center mb-6">
            <img
              src="https://customer-assets-rejwkqb3.emergentagent.net/job_seekho-admin/artifacts/2biwyt6k_6305294127389675025.jpg"
              alt="Ecom Seekho"
              className="w-16 h-16 rounded-lg object-cover mx-auto mb-3 shadow-md"
            />
            <h1 className="text-2xl font-bold text-gray-800">Admin Portal</h1>
            <p className="text-sm text-gray-500 mt-1">Ecom Seekho — Backoffice</p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <Label htmlFor="username">Username</Label>
              <Input
                id="username"
                value={form.username}
                onChange={(e) => setForm({ ...form, username: e.target.value })}
                placeholder="Username"
                required
              />
            </div>
            <div>
              <Label htmlFor="password">Password</Label>
              <Input
                id="password"
                type="password"
                value={form.password}
                onChange={(e) => setForm({ ...form, password: e.target.value })}
                placeholder="••••••"
                required
              />
            </div>
            <Button type="submit" className="w-full bg-emerald-700 hover:bg-emerald-800 text-white">
              <Lock className="w-4 h-4 mr-2" /> Sign In
            </Button>
          </form>

          <div className="mt-6 pt-4 border-t text-center">
            <p className="text-xs text-gray-500">Admin credentials required</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
